import '@styles/index.css';
// eslint-disable-next-line import/order
/**
 * Polyfill for Array.prototype.at / String.prototype.at (ES2022).
 * esbuild's `target` build option only downlevels syntax, it does not
 * polyfill missing runtime methods, so browsers without ES2022 support
 * (e.g. Safari/iOS < 15.4, older in-app webviews) crash with
 * "X.at is not a function" wherever `.at(...)` is used. This app serves
 * the public, unauthenticated /unsubscribe and /subscription-preferences
 * pages, which are disproportionately opened from email/SMS links in
 * older mobile browsers, and its build target (es2015) is older still.
 * @see https://github.com/tc39/proposal-relative-indexing-method
 */
function atPolyfill<T>(this: ArrayLike<T>, index: number): T | undefined {
    let n = Math.trunc(index) || 0;
    if (n < 0) n += this.length;
    if (n < 0 || n >= this.length) return undefined;
    return this[n];
}
// eslint-disable-next-line no-extend-native
if (!Array.prototype.at) Array.prototype.at = atPolyfill;
// eslint-disable-next-line no-extend-native
if (!String.prototype.at) String.prototype.at = atPolyfill;

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

const container = document.getElementById('root');
if (!container) throw new Error('Root element not found!');

const root = createRoot(container);

root.render(
    <StrictMode>
        <App />
    </StrictMode>,
);
